import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Dateable } from 'pkg/api/models/dateable';

export enum GameReportVisibility {
	Invalid = 'invalid',
	Visible = 'visible',
	StaffAndAdmin = 'staffadmin',
}

export interface GameReportAttachment {
	gameReportId: number;
	attachmentId: number;

	gameReport?: GameReport;
	attachment?: models.attachment.Attachment;
}

export interface GameReport extends Dateable, AllowedActionable {
	id: number;
	gameId: number;
	groupId: number;
	userId: number;
	content?: string;
	visibility: GameReportVisibility;

	game: models.game.Game;
	group: models.group.Group;
	user: models.user.User;
	attachments?: GameReportAttachment[];
}
